"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandListerGroupedFilterTypes = exports.FilterContentTypes = exports.SET_ACTIVE_FILTERS = exports.REMOVE_FILTER = exports.SET_FILTERS = exports.LINK_FILTER = exports.BUCKET_FILTER = exports.RANGE_FILTER = exports.MULTISELECT_FILTER = void 0;
exports.MULTISELECT_FILTER = 'MULTISELECT';
exports.RANGE_FILTER = 'RANGE';
exports.BUCKET_FILTER = 'BUCKET';
exports.LINK_FILTER = 'LINK';
exports.SET_FILTERS = 'SET_FILTERS';
exports.REMOVE_FILTER = 'REMOVE_FILTER';
exports.SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
var FilterContentTypes;
(function (FilterContentTypes) {
    FilterContentTypes["SIZE"] = "SIZE";
})(FilterContentTypes || (exports.FilterContentTypes = FilterContentTypes = {}));
var BrandListerGroupedFilterTypes;
(function (BrandListerGroupedFilterTypes) {
    BrandListerGroupedFilterTypes["ALL"] = "all";
    BrandListerGroupedFilterTypes["POPULAR"] = "popular";
    BrandListerGroupedFilterTypes["NUMBERS"] = "0-9";
})(BrandListerGroupedFilterTypes || (exports.BrandListerGroupedFilterTypes = BrandListerGroupedFilterTypes = {}));
//# sourceMappingURL=FilterEnums.js.map